import type { DeliveryGroupDraft } from './deliveryGroupTypes';
import { getLegacyBucketOrderedUids, getPositionOrderedUids } from './editorStopOrdering';
import { isSequentialStopsItineraryShadowDebugEnabled } from './sequentialStopsItineraryFlags';

export type ItineraryShadowSnapshot = {
  positionOrderUids: string[];
  legacyBucketUids: string[];
  positionByUid: Record<string, number | undefined>;
  groupUidByStopUid: Record<string, string>;
  orderMismatch: boolean;
};

export function buildItineraryShadowSnapshot(groups: DeliveryGroupDraft[]): ItineraryShadowSnapshot {
  const positionOrderUids = getPositionOrderedUids(groups);
  const legacyBucketUids = getLegacyBucketOrderedUids(groups);
  const positionByUid: Record<string, number | undefined> = {};
  const groupUidByStopUid: Record<string, string> = {};

  for (const g of groups) {
    for (const s of [...g.loadingStops, ...g.unloadingStops]) {
      positionByUid[s.uid] = s.position;
      groupUidByStopUid[s.uid] = g.uid;
    }
  }

  return {
    positionOrderUids,
    legacyBucketUids,
    positionByUid,
    groupUidByStopUid,
    orderMismatch: positionOrderUids.join('|') !== legacyBucketUids.join('|')
  };
}

export function logItineraryEditorShadow(
  groups: DeliveryGroupDraft[],
  context?: string,
  extra?: { beforeUids?: string[]; afterUids?: string[] }
): void {
  if (!isSequentialStopsItineraryShadowDebugEnabled()) return;
  const snap = buildItineraryShadowSnapshot(groups);
  // eslint-disable-next-line no-console
  console.debug('[SequentialStopsItineraryShadow]', context ?? 'itinerary', {
    ...snap,
    beforeUids: extra?.beforeUids,
    afterUids: extra?.afterUids,
    positionDrift:
      extra?.beforeUids && extra?.afterUids
        ? extra.beforeUids.join('|') !== extra.afterUids.join('|')
        : undefined
  });
}
